// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2CCcF","icon":"style_icon__CraM0"};